import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface ShowersIconPropsType {
    className?: string;
    onClick?: () => void;
}

export const ShowersIcon = observer('ShowersIcon', ({ className, onClick }: ShowersIconPropsType): JSX.Element => {
    return (
        <SvgElement
            className={className}
            fill='currentcolor'
            height='32'
            onClick={onClick}
            viewBox='0 0 32 32'
            width='32'
            xmlns='http://www.w3.org/2000/svg'
            data-test='weather-icon'
        >
            <path
                fill='fill'
                fillRule='evenodd'
                d='M2 13c0 4.363 2.45 8.132 6 9.91V20.6c-2.39-1.585-4-4.37-4-7.6 0-5.04 3.922-9 8.608-9 3.976 0 7.401 2.85 8.349 6.791l.003-.001c.134.547.22 1.114.25 1.696A4.54 4.54 0 0 1 23.25 12c2.555 0 4.75 2.17 4.75 5 0 1.71-.802 3.18-2 4.075v2.32c2.357-1.093 4-3.545 4-6.395a7.132 7.132 0 0 0-1.479-4.372 6.5 6.5 0 0 0-9.753-8.584A10.307 10.307 0 0 0 12.608 2C6.75 2 2 6.925 2 13Zm18.258-7.62a11.091 11.091 0 0 1 2.563 4.634 6.554 6.554 0 0 1 4.255 1.219 4.5 4.5 0 0 0-6.818-5.853Zm-.833 14.6c-.168.29-.496.344-.706.223-.21-.122-.328-.433-.16-.724.214-.37.656-.79 1.24-1.203a8.84 8.84 0 0 1-.078.675c-.086.538-.204.87-.296 1.029Zm2.294-4.976s-.882.334-1.925.918c-1.09.61-2.354 1.494-2.967 2.557-.703 1.218-.304 2.765.892 3.456 1.196.69 2.735.263 3.438-.955.559-.968.687-2.558.682-3.854a19.99 19.99 0 0 0-.12-2.122Zm-8.897 5.993c-.168.291-.496.344-.706.223-.21-.12-.328-.432-.16-.723.214-.37.657-.79 1.24-1.203-.018.233-.044.46-.078.674-.085.54-.204.87-.296 1.03Zm2.294-4.975s-.882.333-1.924.917c-1.09.61-2.355 1.495-2.968 2.558-.703 1.218-.303 2.765.892 3.456 1.196.69 2.735.263 3.438-.955.56-.969.687-2.558.682-3.854a20.008 20.008 0 0 0-.12-2.122Zm5.857 10.314c.21.12.538.068.706-.223.092-.16.21-.49.296-1.03a8.79 8.79 0 0 0 .079-.674c-.584.414-1.027.832-1.241 1.204-.168.29-.05.602.16.723Zm1.076-4.281c1.042-.584 1.924-.918 1.924-.918s.116.94.12 2.122c.005 1.297-.123 2.886-.682 3.854-.703 1.218-2.242 1.645-3.438.955-1.195-.69-1.595-2.238-.892-3.456.613-1.063 1.878-1.947 2.968-2.557Zm-7.088 5.66c-.168.29-.497.344-.706.223-.21-.122-.328-.433-.16-.724.214-.37.656-.79 1.24-1.203a8.79 8.79 0 0 1-.078.674c-.086.54-.204.87-.296 1.03Zm2.294-4.976s-.882.334-1.925.918c-1.09.61-2.354 1.494-2.967 2.557-.703 1.218-.304 2.765.892 3.456 1.196.69 2.735.263 3.438-.955.559-.968.687-2.558.682-3.854-.004-1.183-.12-2.122-.12-2.122Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
